import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { convertToDate, interpolate, deviceChange, isMobileQuery, MagicConfigMixin, ContentMixin } from '@gig/magic-common';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { getPaymentMethod } from '../../store/modules/transactions/transactions.store.js';

var SweepstakesTransactionMixin = /** @class */ (function (_super) {
    __extends(SweepstakesTransactionMixin, _super);
    function SweepstakesTransactionMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMobile = false;
        _this.scrollToBottomOfPayment = function () {
            setTimeout(function () {
                var gamingElement = _this.$refs.history;
                gamingElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }, 50);
        };
        return _this;
    }
    Object.defineProperty(SweepstakesTransactionMixin.prototype, "fromDate", {
        get: function () {
            return convertToDate(this.from);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesTransactionMixin.prototype, "toDate", {
        get: function () {
            return convertToDate(this.to);
        },
        enumerable: false,
        configurable: true
    });
    SweepstakesTransactionMixin.prototype.getIdLabel = function (item) {
        return interpolate(this.$t('sweepx-transactions.id.header'), {
            id: item.TransactionId,
        });
    };
    SweepstakesTransactionMixin.prototype.getPaymentMethod = function (item) {
        try {
            var PaymentMethod = getPaymentMethod(item);
            var translation = this.$t("payment-transactions.payment-method." + PaymentMethod.replaceAll(/\s/g, ''));
            return translation !== '' ? translation : PaymentMethod;
        }
        catch (_a) {
            return '-';
        }
    };
    SweepstakesTransactionMixin.prototype.created = function () {
        var _this = this;
        this.deviceSubscription = deviceChange(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, isMobileQuery()];
                    case 1:
                        _a.isMobile = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    SweepstakesTransactionMixin.prototype.destroyed = function () {
        var _a;
        (_a = this.deviceSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    __decorate([
        Prop({
            type: [Number, String, Date],
        }),
        __metadata("design:type", Object)
    ], SweepstakesTransactionMixin.prototype, "from", void 0);
    __decorate([
        Prop({
            type: [Number, String, Date],
        }),
        __metadata("design:type", Object)
    ], SweepstakesTransactionMixin.prototype, "to", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        }),
        __metadata("design:type", Boolean)
    ], SweepstakesTransactionMixin.prototype, "isAdvancedSearch", void 0);
    SweepstakesTransactionMixin = __decorate([
        Component
    ], SweepstakesTransactionMixin);
    return SweepstakesTransactionMixin;
}(Mixins(MagicConfigMixin, ContentMixin)));

export { SweepstakesTransactionMixin };
